import { escapeRegExp } from './escape-regex.function';
import { isDefined } from './is-defined.function';

export interface SearchOptions {
  wholeWord?: boolean;
  caseSensitive?: boolean;
  regex?: boolean
}

export function search<T>(items: T[], searchTerm: string, options?: SearchOptions | null): T[] {
  if (searchTerm.length === 0)
    return items;

  const predicate = getPredicate(searchTerm, options);
  return items.filter((item) => containsTerm(item, predicate));
}

function getPredicate(searchTerm: string, options?: SearchOptions | null): (text: string) => boolean {
  let predicate: (text: string) => boolean;
  if(options?.regex) {
    const regex = new RegExp(options.wholeWord ? `^${searchTerm}$` :searchTerm, options.caseSensitive ? 'g' : 'gi');
    predicate = o => regex.test(o);
  }
  else if(options?.wholeWord) {
    const excapedTerm = escapeRegExp(searchTerm);
    const regex = new RegExp(`\\b${excapedTerm}\\b`, options.caseSensitive ? 'g' : 'gi');
    predicate = o => regex.test(o);
  }
  else {
    if(options?.caseSensitive)
      predicate = o => o.includes(searchTerm)
    else {
      const lowerSearchTerm = searchTerm.toLowerCase();
      predicate = o => o.toLowerCase().includes(lowerSearchTerm);
    }
  }
  return predicate
}

function containsTerm<T>(item: T, predicate: (text: string) => boolean): boolean {
  const stack: any[] = [];
  stack.push(item);
  while (stack.length > 0) {
    const currentValue = stack.pop();
    if (!isDefined(currentValue))
      continue;

    switch (typeof currentValue) {
      case 'string':
        if(predicate(currentValue))
          return true;
        break;
      case 'number':
        if (predicate('' + currentValue))
          return true;
        break;
      case 'object':
        if (Array.isArray(currentValue))
          stack.push(...currentValue);
        else
          stack.push(...Object.values(currentValue))
        break;
      default:
        break;
    }
  }
  return false;
}
